module.exports = __webpack_public_path__ + "img/prev.da6b2a35.svg";